import React, {useCallback, useState} from 'react'
import Modal from "../../Modal/Modal";
import {useToast} from "../../../../context/ToastContext";
import {Divider, ModalBody} from "./NewsletterModal.styles";

function NewsletterModal({
                           isOpen,
                           onClose,
                           resubscribeLink
                         }) {
  const [loading, setLoading] = useState(false)
  const {showToast} = useToast()

  const onUnsubscribe = useCallback(() => {
    showToast("Newsletter subscribe", "You have successfully unsubscribed from the newsletter..")

    onClose();
  }, [onClose]);

  const onKeepSubscribed = useCallback(() => {
    setLoading(true);
    const link = document.createElement("a");
    link.href = resubscribeLink;
    link.target = "_blank";
    link.click();

    showToast("Newsletter resubscribe", "You have successfully resubscribed to the newsletter..")

    // fetch(resubscribeLink)
    //   .then(() => {
    //     showToast("Newsletter resubscribe", "You have successfully resubscribed to the newsletter..")
    //   }).catch(err => {
    //   showToast("Newsletter resubscribe failed.", err?.message || "Unavailable reason")
    // }).finally(() => setLoading(false))

    setLoading(false);

    onClose();
  }, [resubscribeLink, onClose]);

  return (
    <Modal
      title={"Unsubscribe from Emails"}
      subTitle=''
      isLoading={loading}
      isOpen={isOpen}
      onClose={onUnsubscribe}
      onSecondaryButton={onKeepSubscribed}
      onSubmit={onUnsubscribe}
      primaryButtonText="Unsubscribe"
      secondaryButtonText="Keep me subscribed"
    >
      <ModalBody>
        <p>We're sorry to see you go!</p>
        <p>Are you sure you want to unsubscribe from our email notifications?</p>
        <Divider/>
        <p>You’ll stop receiving:</p>
        <ul>
          <li>Product updates</li>
          <li>Special offers</li>
          <li>Helpful tips and news</li>
        </ul>
      </ModalBody>
    </Modal>
  )
}

export default NewsletterModal
